export const EXTENSION_MIME: Record<string, string> = {
  ".geojson": "application/geo+json",
  ".json": "application/json",
  ".kml": "application/vnd.google-earth.kml+xml",
  ".kmz": "application/vnd.google-earth.kmz",
  ".shp": "application/vnd.shp",
  ".shx": "application/vnd.shx",
  ".dbf": "application/vnd.dbf",
  ".prj": "text/plain",
  ".las": "application/octet-stream",
  ".zip": "application/zip",
  ".csv": "text/csv",
  ".pdf": "application/pdf",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

export const acceptedExtensions = {
  images: {
    "image/jpeg": [".jpg", ".jpeg", ".rjpeg"],
  },
  pointclouds: {
    "application/octet-stream": [".las"],
  },
  geometry: {
    "application/geo+json": [".geojson"],
    "application/json": [".json"],
    "application/vnd.google-earth.kml+xml": [".kml"],
    "application/vnd.google-earth.kmz": [".kmz"],
    "application/vnd.shp": [".shp"],
    "application/vnd.shx": [".shx"],
    "application/vnd.dbf": [".dbf"],
    "text/plain": [".prj"],
    "application/zip": [".zip"],
    "text/csv": [".csv"],
    "application/pdf": [".pdf"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
      ".xlsx",
    ],
  },
};

export function extOf(name: string) {
  return (name.match(/\.[^.]+$/)?.[0] || "").toLowerCase();
}

export function guessMimeFromExt(file: File) {
  return file.type || EXTENSION_MIME[extOf(file.name)] || "";
}

export function acceptedImageFiles(files: File[]) {
  return files.filter((file) => {
    return Object.values(acceptedExtensions.images)
      .flat()
      .includes(`.${file.name.toLowerCase().split(".").pop()}`);
  });
}

export function acceptedPointcloudFiles(files: File[]) {
  return files
    .filter((file) =>
      Object.values(acceptedExtensions.pointclouds)
        .flat()
        .includes(`.${file.name.toLowerCase().split(".").pop()}`)
    )
    .map(
      (file) =>
        new File([file], file.name, {
          type: guessMimeFromExt(file),
          lastModified: file.lastModified,
        })
    );
}

export function acceptedGeometryFiles(files: File[]) {
  return files
    .filter((file) =>
      Object.values(acceptedExtensions.geometry)
        .flat()
        .includes(`.${file.name.toLowerCase().split(".").pop()}`)
    )
    .map(
      (file) =>
        new File([file], file.name, {
          type: guessMimeFromExt(file),
          lastModified: file.lastModified,
        })
    );
}
